import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Consignment, ConsignmentData } from "./Consignment";

const BdpConsignment = () => {
	const { t } = useTranslation();

	const data: ConsignmentData = {
		groups: [
			{
				header: t("PRIVACY_BDP_CONSIGNMENT_COMPANY_KR"),
				columns: [
					[
						t("PRIVACY_BDP_CONSIGNMENT_SAMSUNG_KR"),
						<Trans
							key="google-kr"
							i18nKey="PRIVACY_BDP_CONSIGNMENT_GOOGLE_KR"
							components={{
								a: (
									// eslint-disable-next-line
									<a
										href="https://cloud.google.com/terms/subprocessors"
										target="_blank"
										rel="noreferrer"
									/>
								),
							}}
						/>,
					],
					[
						t("PRIVACY_BDP_CONSIGNMENT_SAMSUNG_OPERATIONS_KR"),
						<Trans
							key="google-ops-kr"
							i18nKey="PRIVACY_BDP_CONSIGNMENT_GOOGLE_OPERATIONS_KR"
							components={{
								a: (
									// eslint-disable-next-line
									<a
										href="https://cloud.google.com/terms/subprocessors"
										target="_blank"
										rel="noreferrer"
									/>
								),
							}}
						/>,
					],
				],
			},
			{
				header: t("PRIVACY_BDP_CONSIGNMENT_COMPANY"),
				columns: [
					[
						t("PRIVACY_BDP_CONSIGNMENT_SAMSUNG"),
						<Trans
							key="google-en"
							i18nKey="PRIVACY_BDP_CONSIGNMENT_GOOGLE"
							components={{
								a: (
									// eslint-disable-next-line
									<a
										href="https://cloud.google.com/terms/subprocessors"
										target="_blank"
										rel="noreferrer"
									/>
								),
							}}
						/>,
					],
					[
						t("PRIVACY_BDP_CONSIGNMENT_SAMSUNG_OPERATIONS"),
						<Trans
							key="google-ops-en"
							i18nKey="PRIVACY_BDP_CONSIGNMENT_GOOGLE_OPERATIONS"
							components={{
								a: (
									// eslint-disable-next-line
									<a
										href="https://cloud.google.com/terms/subprocessors"
										target="_blank"
										rel="noreferrer"
									/>
								),
							}}
						/>,
					],
				],
			},
		],
	};

	return <Consignment data={data} testId="bdp-consignment" />;
};

export default BdpConsignment;
